export default __webpack_public_path__ + "static/media/template.ce005cc7.png";